



















































































































import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";

// 模拟临床试验数据：保持原有showEap配置不变
const clinicalTrialsData = [
  {
    id: "DF003-002",
    title: "Phase 1b Study of DF-003 in ROSAH Syndrome Patients",
    phase: "Phase 1b",
    status: "Recruiting",
    therapyArea: "Rare Diseases/Ophthalmology/Immunology",
    location: "Australia, China, United States",
    description: "This open-label trial evaluates the safety, tolerability, and pharmacokinetics of orally administered DF-003 in patients with ROSAH (Retinal dystrophy, Optic nerve edema, Splenomegaly, Anhidrosis, and Headache) syndrome to determine the optimal therapeutic dose.",
    nctId: "NCT06395285",
    requirements: "18 - 65 years, Male & Female.",
    showEap: true // 显示EAP标识
  },
  {
    id: "DF003-001",
    title: "Phase 1 Study of DF-003 in Healthy Volunteers",
    phase: "Phase 1",
    status: "Completed",
    therapyArea: "Cardio-renal diseases/Ophthalmology",
    location: "United States",
    description: "This first-in-human, double-blind, placebo-controlled trial assessed the safety, tolerability, and pharmacokinetics of single and multiple ascending doses of DF-003 in healthy participants.",
    nctId: "NCT05997641",
    requirements: "18 - 55 years, Male & Female.",
    showEap: false // 隐藏EAP标识
  },
  {
    id: "DF006-002",
    title: " Phase 1 Trial of DF-006 in Patients with Chronic Hepatitis B",
    phase: "Phase 1",
    status: "Completed",
    therapyArea: "Infectious Diseases/Chronic Hepatitis B",
    location: "New Zealand, Moldova, Ukraine",
    description: "A Phase 1, Double-blind, Randomized, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After Multiple Doses of Orally Administered DF-006 in Chronic Hepatitis B Patients (Part 3).",
    anzctrId: "ACTRN12623000997651",
    requirements: "18 - 65 years, Male & Female.",
    showEap: false // 隐藏EAP标识
  },
  {
    id: "DF006-001",
    title: " Phase 1 Trial of DF-006 in Healthy Volunteers",
    phase: "Phase 1",
    status: "Completed",
    therapyArea: "Infectious Diseases/Chronic Hepatitis B",
    location: "New Zealand, Korea",
    description: "A Phase 1, Double-blind, Randomized, Placebo-controlled, First-in-human Study of Orally Administered DF-006 to Evaluate the Safety, Tolerability, and Pharmacokinetics After a Single Dose and Multiple Doses of Orally Administered DF 006 in Healthy Subjects (Part 1 and Part 2).",
    anzctrId: "ACTRN12621000592842",
    requirements: "18 - 55 years, Male & Female.",
    showEap: false // 隐藏EAP标识
  }
];

// 处理原始数据：保持原有逻辑不变
const processedTrialsData = clinicalTrialsData.map(trial => ({
  ...trial,
  therapyAreaArray: trial.therapyArea.split('/').map(area => area.trim())
}));

export default Vue.extend({
  name: "ClinicalTrials",
  components: {
    HeaderImg
  },
  data() {
    return {
      clinicalTrialsHeaderImg: {
        path: "clinical-trials",
        image: "",
        imageAlt: "clinical trials top img"
      },
      trialsList: processedTrialsData,
      searchKeyword: "",
      selectedPhase: "",
      selectedStatus: "",
      selectedTherapyArea: "",
      filteredTrials: [] as any[],
      phaseOptions: [] as string[],
      statusOptions: [] as string[],
      therapyAreaOptions: [] as string[]
    };
  },
  created() {
    this.clinicalTrialsHeaderContent();
    this.initFilterOptions();
    this.filteredTrials = [...this.trialsList];
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();
    window.addEventListener("resize", () => this.clinicalTrialsHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => this.clinicalTrialsHeaderContent());
  },
  methods: {
    setRevealAnimation() {
      ScrollReveal().reveal(`[v-scrollReveal]`, scrollConfig);
    },
    clinicalTrialsHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.clinicalTrialsHeaderImg = {
        ...this.clinicalTrialsHeaderImg,
        image: desktopViewport
          ? "desktop_clinical_trials_top_img.jpg"
          : "mobile_clinical_trials_top_img.jpg"
      };
    },
    initFilterOptions() {
      const allPhases = [...new Set(this.trialsList.map(trial => trial.phase))];
      this.phaseOptions = allPhases.sort();

      const allStatuses = [...new Set(this.trialsList.map(trial => trial.status))];
      this.statusOptions = allStatuses.sort();

      const allAreas: string[] = [];
      this.trialsList.forEach(trial => {
        trial.therapyAreaArray.forEach(area => {
          if (!allAreas.includes(area)) {
            allAreas.push(area);
          }
        });
      });
      this.therapyAreaOptions = allAreas.sort();
    },
    handleSearch() {
      this.filterTrials();
    },
    handleFilter() {
      this.filterTrials();
    },
    filterTrials() {
      let filtered = [...this.trialsList];

      if (this.searchKeyword) {
        const keyword = this.searchKeyword.toLowerCase();
        filtered = filtered.filter(
          trial =>
            trial.title.toLowerCase().includes(keyword) ||
            trial.description.toLowerCase().includes(keyword)
        );
      }

      if (this.selectedPhase) {
        filtered = filtered.filter(trial => trial.phase === this.selectedPhase);
      }

      if (this.selectedStatus) {
        filtered = filtered.filter(trial => trial.status === this.selectedStatus);
      }

      if (this.selectedTherapyArea) {
        filtered = filtered.filter(trial => 
          trial.therapyAreaArray.includes(this.selectedTherapyArea)
        );
      }

      this.filteredTrials = filtered;
    }
  }
});
